
const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";

export const showErrorMessages = (data: any) => {
    return {
        type: SHOW_ERROR_MESSAGE,
        payload: data
    }
};
